import React from "react";
import {
  RefundRequestComponent,
  RefundRequestComponentType,
  RefundRequestComponentStatus,
} from "../../../common/types";
import { Panel, Header, Table } from "@glamcorner/components";
import "./refund-request-components-table-card.scss";
import { TableHeaderItem, TableHeaders, TableBody } from "@glamcorner/components/lib/core/components/Table";
import { RefundRequestComponentTableRow } from "../RefundRequestComponentTableRow";

interface RefundRequestComponentsTableCardProps {
  components: RefundRequestComponent[];
  statusOnChange: ({
    type,
    status,
  }: {
    type: RefundRequestComponentType;
    status: RefundRequestComponentStatus;
  }) => void;
  allChecklistItemsComplete: boolean;
}

export const RefundRequestComponentsTableCard: React.FC<RefundRequestComponentsTableCardProps> = ({
  components,
  statusOnChange,
  allChecklistItemsComplete,
}) => {
  const headerItems: TableHeaderItem[] = [
    { text: "Type", align: "left" },
    { text: "Status", align: "left" },
    { text: "Amount", align: "right" },
    { text: "Updated At", align: "left" },
    { text: "Actions", align: "left" },
  ];

  const withComponents = components.length > 0;

  return (
    <Panel className="c-refund-request-components-table-card" ready={true}>
      <Header onClick={() => {}} withCloseButton={false}>
        Refund Parts
      </Header>

      <div className="c-refund-request-components-table-card__content">
        <div className="c-refund-request-screen__explain-text">
          The refund will be provided to the customer in one or more parts, depending on the original payment method
          used and whether the customer requires cash or store credit.
          <br />
          <span>
            When all checklist items are checked, the refund parts will processed automatically in the next batch
            process.
          </span>
        </div>

        {withComponents ? (
          <Table className="c-refund-request-components-table-card__table">
            <TableHeaders items={headerItems} />
            <TableBody>
              {components.map(component => (
                <RefundRequestComponentTableRow
                  key={component.type}
                  component={component}
                  statusOnChange={statusOnChange}
                  allChecklistItemsComplete={allChecklistItemsComplete}
                />
              ))}
            </TableBody>
          </Table>
        ) : (
          <div>No components available</div>
        )}
      </div>
    </Panel>
  );
};
